import React, { useContext } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import AppContext from '../../AppContext';
import config from '../../config';

const Auth0IdleTimer = ({ AuthClient, intervalFunction }) => {
  const context = useContext(AppContext);
  const handleOnIdle = () => {
    context.state = {};
    window.localStorage.setItem("callbackURL", (window.location.pathname !== "/callback" && window.location.pathname !== "/logout") ? window.location.pathname : "/")
    clearInterval(intervalFunction);
    sessionStorage.clear();
    AuthClient.logout({ logoutParams: { returnTo: config.auth0.logoutRedirectUrl } });
  };

  useIdleTimer({
    timeout: 1000 * 60 * config.auth0.idleTimeout,
    onIdle: handleOnIdle,
    debounce: 250,
  });

  return null;
};

export default Auth0IdleTimer;
